import { createContext } from 'react';
import type { CustomControlCode } from '@common/enums';
import type { InputField } from '@common/formEngine/formEngine.types';

export type EditFormContextValue<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
> = Readonly<{
    onChange: (value: unknown, field: InputField<Data, TCustomControlCode, Version>) => void | Promise<void>;
}>;

export const EditFormContext = createContext<EditFormContextValue | null>(null);
